<template>
  <div>
    <h1 v-if="showHeader" class="mb-3">Datenschutzbestimmungen</h1>

    <static-content which="privacy-policy"/>
  </div>
</template>

<script>
import StaticContent from "@/widgets/StaticContent"

export default {
  name: "PrivacyPolicy",
  components: {
    StaticContent,
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
h2 {
  margin-bottom: 0.1em;
}
</style>
